"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deleteFilterDrawer = _interopRequireDefault(require("./delete-filter-drawer"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = _deleteFilterDrawer.default;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/components/pages/notifications-page/delete-filter-drawer/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEZWxldGVGaWx0ZXJEcmF3ZXIiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wYWdlcy9ub3RpZmljYXRpb25zLXBhZ2UvZGVsZXRlLWZpbHRlci1kcmF3ZXIvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERlbGV0ZUZpbHRlckRyYXdlciBmcm9tICcuL2RlbGV0ZS1maWx0ZXItZHJhd2VyJztcblxuZXhwb3J0IGRlZmF1bHQgRGVsZXRlRmlsdGVyRHJhd2VyO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFBd0Q7RUFBQTtFQUFBO0FBQUE7QUFBQTtFQUFBO0FBQUE7QUFBQSxlQUV6Q0EsMkJBQWtCO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtBQUFBIn0=